<template>
  <div class="container" v-if="formValidConfig">
    <ul v-if="!formValid">
      <li v-for="(error, idx) in formDataErrors" :key="idx">{{ error }}</li>
    </ul>
    <form id="pva-form" @submit.prevent="submit">
      <div class="row">
        <div class="col-25">
          <label for="fname">First Name</label>
        </div>
        <div class="col-75">
          <input
            type="text"
            id="fname"
            name="firstname"
            placeholder="Your name.."
            required
            v-model="formData.firstName"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-25">
          <label for="lastname">Last Name</label>
        </div>
        <div class="col-75">
          <input
            type="text"
            id="lname"
            name="lastname"
            placeholder="Your last name.."
            required
            v-model="formData.lastName"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-25">
          <label for="email">Email Address</label>
        </div>
        <div class="col-75">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email Address"
            required
            v-model="formData.email"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-25">
          <label for="phone">Phone</label>
        </div>
        <div class="col-75">
          <input
            type="text"
            id="phone"
            name="phone"
            placeholder="Enter your phone number"
            v-model="formData.phone"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-25">
          <label for="tentativeDate">Booking Date</label>
        </div>
        <div class="col-75">
          <input
            type="date"
            id="tentativeDate"
            name="Booking Date"
            required
            v-model="formData.tentativeDate"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-25">
          <label for="message">Message</label>
        </div>
        <div class="col-75">
          <textarea
            id="message"
            name="message"
            placeholder="Additional Info"
            style="height:200px"
            v-model="formData.message"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <input type="submit" value="Submit" />
      </div>
    </form>
    <p v-if="formSubmitted">Enquiry form successfully submitted</p>
  </div>
</template>

<script>
import Vue from "vue";
import config from "../config.js";
export default {
  name: "EnquiryForm",
  props: { user:{type:String,required: true,}, location: {type:String,required: true,} },
  data() {
    return {
      formData: {
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        enquiryDate: new Date(),
        tentativeDate: undefined,
        message: "",
      },
      formDataErrors: [],
      formValid: true,
      formValidError: "Enquiry form has missing configuration parameters",
      formSubmitted: false,
      formValidConfig: false
    };
  },
  methods: {
    submit() {
      console.info("submitting form");
      this.formDataErrors = []

      if (!this.formData.firstName) {
        this.formDataErrors.push("First Name is a Required Field");
        this.formValid = false;
      }
      if (!this.formData.lastName) {
        this.formDataErrors.push("Last Name is a Required Field");
        this.formValid = false;
      }
      if (!this.formData.email) {
        this.formDataErrors.push("Email is a Required Field");
        this.formValid = false;
      }
      if (!this.formData.phone) {
        this.formDataErrors.push("Phone is a Required Field");
        this.formValid = false;
      }

      if (this.formValid) {
        console.log(config.submitFn);
        Vue.axios
          .post(config.submitFn, {
            id: this.user,
            location: this.location,
            formData: this.formData,
          })
          .then((response) => {
              console.log("submit response",response)
            if (response.received) {
              this.formValid = true;
              this.formSubmitted = true;
              this.formDataErrors = [];
            }
          })
          .catch((error) => {
            this.formValid = false;
            this.formDataErrors = [];
            this.formDataErrors.push(error);
          });
      }
    },
  },
  mounted() {
      console.log(process.env.VUE_APP_FORM_SUBMIT_FUNCTION,config)
      if(!this.user && !this.location){
           console.error("Invalid form configuration");
      }else{
          console.info("Valid form configuration");
          this.formValidConfig = true;
      }
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

input[type="text"],
input[type="email"],
input[type="date"],
select,
textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

label {
  padding: 12px 12px 12px 0;
  display: inline-block;
}

input[type="submit"] {
  background-color: #04aa6d;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;
}

input[type="submit"]:hover {
  background-color: #45a049;
}

.container {
  border-radius: 5px;
  background-color: #f2f2f2;
  padding: 20px;
}

.col-25 {
  float: left;
  width: 25%;
  margin-top: 6px;
}

.col-75 {
  float: left;
  width: 75%;
  margin-top: 6px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .col-25,
  .col-75,
  input[type="submit"] {
    width: 100%;
    margin-top: 0;
  }
}
</style>
